;
(function ($) {
    "use strict";

    /**
     * show_posts - Collapse
     *
     */

    var $containers = $('.mat_show_posts_shortcode-container.collapse');

    if ($containers.length) {
        $containers.on('click', '.toggle-content', function (ev) {
            reset_containers();
            $(this).hide(100);
            $(this).closest('.content').find('.partial-content').slideUp(300);
            $(this).closest('.content').find('.full-content').slideDown(300, function () {
                $('html, body').animate({
                    scrollTop: $(this).offset().top - 100
                }, 800);
            });
        });

    }

    function reset_containers() {

        $containers.find('.toggle-content').show(100);
        $containers.find('.partial-content').show(100);
        $containers.find('.full-content').hide(300);

    }


})(jQuery);